/*
 * - typeId (идентификатор типа идентификации)
 * - code (код, получаемый при интеграции MYID)
*/
export default (axios, { typeId, code }) => axios.post('/identification/', { typeId, code });
